module.exports = __webpack_public_path__ + "cfa8d56280076e5e7d4ec508a5b59cb8.pdf";